export default "__VITE_ASSET__CmYorjOS__"